import { styled } from '../../../theme/stitches.config';
import type * as Stitches from '@stitches/react';

export const SMPIcon = styled('svg', {
  variants: {
    width: {
      '1': {
        width: '$1',
      },
      '2': {
        width: '$2',
      },
      '3': {
        width: '$3',
      },
      '4': {
        width: '$4',
      },
      '5': {
        width: '$5',
      },
    },
    height: {
      '1': {
        height: '$1',
      },
      '2': {
        height: '$2',
      },
      '3': {
        height: '$3',
      },
      '4': {
        height: '$4',
      },
      '5': {
        height: '$5',
      },
    },
    variant: {
      contrast: {
        color: '$hiContrast',
      },
    },
  },
  defaultVariants: {
    variant: 'contrast',
  },
});

export type StyledIconVariants = Stitches.VariantProps<typeof SMPIcon>;
